<div *ngIf="show" class="spinner-wrapper">
  <div class="ring">
    <div class="spinner"></div>
  </div>
</div>
